import { createAction, props } from '@ngrx/store';
import {
	MonthlyStatistik,
	StatistikResource,
	VerfahrenAktionStatistik,
	ZaehlblattStatistikResource,
} from './statistik.model';
import { Moment } from 'moment';

const PREFIX = '[Statistik] ';

export const loadStatistikAction = createAction(PREFIX + 'Load Statistik');

export const statistikLoadedAction = createAction(
	PREFIX + 'Load Statistik Success',
	props<{
		statistik: StatistikResource;
	}>()
);

export const loadMonthlyStatistikAction = createAction(PREFIX + 'Load Monthly Statistik');

export const monthlyStatistikLoadedAction = createAction(
	PREFIX + 'Load Monthly Statistik Success',
	props<{
		statistik: MonthlyStatistik;
	}>()
);

export const loadZaehlblattStatistikAction = createAction(PREFIX + 'Load Zaehlblatt Statistik');

export const zaehlblattStatistikLoadedAction = createAction(
	PREFIX + 'Load Zaehlblatt Statistik Success',
	props<{
		statistik: ZaehlblattStatistikResource;
	}>()
);

export const loadVerfahrenAktionStatistikAction = createAction(
	PREFIX + 'Load Verfahren Aktion Statistik',
	props<{
		von: Moment;
		bis: Moment;
	}>()
);

export const loadVerfahrenAktionStatistikSuccessAction = createAction(
	PREFIX + 'Load Verfahren Aktion Statistik Success',
	props<{
		statistik: VerfahrenAktionStatistik;
	}>()
);
